export default __webpack_public_path__ + "static/media/Company3.b59345f3.png";